import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _InitializeSubscriptionRequestDtoSchema = z.object({
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
  facilityId: z.number().optional(),
});

const InitializeSubscriptionResponseDtoSchema = z.object({
  createdCount: z.number(),
  initialized: z.boolean(),
});

export type InitializeSubscriptionRequestDto = z.infer<
  typeof _InitializeSubscriptionRequestDtoSchema
>;
export type InitializeSubscriptionResponseDto = z.infer<
  typeof InitializeSubscriptionResponseDtoSchema
>;

export const initializeSubscription = (
  params: InitializeSubscriptionRequestDto,
  config?: AxiosRequestConfig<InitializeSubscriptionRequestDto>
) => {
  return api
    .post('market-intel-subscription', params, config)
    .then(responseContract(InitializeSubscriptionResponseDtoSchema));
};
